// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUp_container__WA6fB","form-container":"SignUp_form-container__1AF8K","signup-forgot":"SignUp_signup-forgot__20Kn6"};